var _rect, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStartPointLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124 26",
    width: 124,
    height: 26,
    role: "img",
    "aria-label": "Start Point",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 7,
    width: 5,
    height: 12,
    rx: 1,
    fill: "#f4b400"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 11,
    y: 18.5,
    fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: 0.6,
    fill: "#ffffff"
  }, "START", /*#__PURE__*/React.createElement("tspan", {
    fill: "#f4b400",
    dx: 4
  }, "POINT"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartPointLogo);
export default __webpack_public_path__ + "static/media/startPointLogo.585a07c4615e051937b41d0733c5bf40.svg";
export { ForwardRef as ReactComponent };